module.exports = __webpack_public_path__ + "static/media/salao_atico_7.ef384cb3.jpg";